import el from './el.json';
import en from './en.json';

export default { en, el };